module.exports = __webpack_public_path__ + "img/Icon6.a764d2c9.png";